import gql from "graphql-tag";
import { QueryHookOptions, useQuery } from "@apollo/client";

import { CredentialFragment, CREDENTIAL_FRAGMENT } from "../../fragments";

export const GET_CREDENTIAL = gql`
  query getCredential @client {
    credential @client(always: true) {
      ...CredentialFragment
    }
  }
  ${CREDENTIAL_FRAGMENT}
`;

export type ActivitiesData = { activities: CredentialFragment[] };

export default (
  options?: QueryHookOptions<ActivitiesData>
) => {
  return useQuery<ActivitiesData>(
    GET_CREDENTIAL,
    options
  );
};
